import React from "react";
import { Message, Grid, Image, Embed } from "lib/components/index";
import CSSModules from "lib/utils/css-modules";
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from "react-sortable-hoc";

import st from "lib/utils/index";
import * as FormControl from "lib/components/FormControl";
import { AttachmentDecorator } from "lib/decorators/index";
import styles from "./ProductImagesFormSection.less";

const DragHandle = SortableHandle(() => <i className="icon material-icons">drag_handle</i>);

@CSSModules(styles)
class AttachmentFormSection extends React.PureComponent {
  handlePropChange(prop, value) {
    const { attachment, onChange } = this.props;
    const nextAttachment = new AttachmentDecorator({
      ...attachment,
      [prop]: value,
    });
    onChange(nextAttachment);
  }

  handleRemoveClick(event) {
    this.props.onRemove();
  }

  renderContents() {
    const { readOnlyAccess, sortable, attachment, name, errors, isMainImage } = this.props;
    if (attachment.type === "Attachment::File") {
      return (
        <div>
          <Image src={attachment.file.url} height="150" width="100%" />

          {isMainImage && (
            <div styleName="attachment-label">{I18n.t("papp.products.EditProductView.StepPhotos.cover_photo")}</div>
          )}

          {!readOnlyAccess && sortable && (
            <div styleName="attachment-drag-btn">
              <DragHandle />
            </div>
          )}
          {!readOnlyAccess && (
            <div styleName="attachment-delete-btn">
              <FormControl.DeleteRowButton onClick={this.handleRemoveClick.bind(this)} innerAlign="center" />
            </div>
          )}

          <div className="fields inline">
            <FormControl.InputFormGroup
              {...FormControl.addProps(`${name}.name`, { errors })}
              value={attachment.name}
              onChange={this.handlePropChange.bind(this, "name")}
              placeholder={I18n.t("papp.products.EditProductView.StepPhotos.name_placeholder")}
              wrapperClassName="flexGrow"
              className="fluid"
              readOnly={readOnlyAccess}
            />
          </div>
        </div>
      );
    } else if (attachment.type === "Attachment::Video") {
      return (
        <div>
          <Image src={attachment.video_image_url} height="150" width="100%" />

          {!readOnlyAccess && sortable && (
            <div styleName="attachment-drag-btn">
              <DragHandle />
            </div>
          )}
          {!readOnlyAccess && (
            <div styleName="attachment-delete-btn">
              <FormControl.DeleteRowButton onClick={this.handleRemoveClick.bind(this)} innerAlign="center" />
            </div>
          )}

          <div className="fields inline">
            <label className="flexGrow">
              <a href={attachment.video_url} target="_blank">
                Film
              </a>
            </label>
          </div>
        </div>
      );
    }
  }

  render() {
    const { isMainImage } = this.props;
    return <div styleName={isMainImage ? "attachment--cover" : "attachment--single"}>{this.renderContents()}</div>;
  }
}
const SortableAttachmentFormSection = SortableElement(AttachmentFormSection);

const AttachmentsList = ({
  readOnlyAccess,
  attachments,
  name,
  errors,
  onItemChange,
  onItemRemove,
  sortable = false,
}) => {
  const mainImageAttachment = attachments && attachments.find((at) => at.type === "Attachment::File");
  const AttachmentFormSectionComponent = sortable ? SortableAttachmentFormSection : AttachmentFormSection;
  return (
    <div className={styles["attachments"]}>
      {attachments.map((attachment, i) => (
        <AttachmentFormSectionComponent
          key={`attachment-${i}`}
          readOnlyAccess={readOnlyAccess}
          sortable={sortable}
          index={i}
          attachment={attachment}
          name={`${name}[${attachment.uuid}]`}
          errors={errors}
          isMainImage={attachment === mainImageAttachment}
          onChange={onItemChange}
          onRemove={onItemRemove && onItemRemove.bind(null, attachment)}
        />
      ))}
    </div>
  );
};
const SortableAttachmentsList = SortableContainer(AttachmentsList);

@CSSModules(styles)
export default class ProductImagesFormSection extends React.PureComponent {
  handleAttachmentChange(nextAttachment) {
    const { attachments, onChange } = this.props;
    const nextAttachments = attachments.map((at) => (at.uuid === nextAttachment.uuid ? nextAttachment : at));
    onChange(nextAttachments);
  }

  handleAttachmentRemove(attachment) {
    const { attachments, onChange } = this.props;
    const nextAttachments = attachments.filter((at) => at.uuid !== attachment.uuid);
    onChange(nextAttachments);
  }

  handleAttachmentMove(prevIndex, nextIndex) {
    const { attachments, onChange } = this.props;
    const nextAttachments = st.normalizePositions(arrayMove(attachments, prevIndex, nextIndex));
    onChange(nextAttachments);
  }

  render() {
    const { readOnlyAccess, attachments, name, errors } = this.props;
    return (
      <div styleName="container">
        {!!errors[name] && <FormMessage error={errors[name]} />}
        {readOnlyAccess && (
          <AttachmentsList readOnlyAccess={readOnlyAccess} sortable={false} attachments={attachments} />
        )}
        {!readOnlyAccess && (
          <SortableAttachmentsList
            readOnlyAccess={readOnlyAccess}
            sortable
            useDragHandle
            axis="xy"
            attachments={attachments}
            name={name}
            errors={errors}
            onItemChange={this.handleAttachmentChange.bind(this)}
            onItemRemove={this.handleAttachmentRemove.bind(this)}
            onSortEnd={({ oldIndex, newIndex }) => this.handleAttachmentMove(oldIndex, newIndex)}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPhotos/ProductImagesFormSection.jsx